module.exports = "/fast-coin/img/coin/anim/shine_1/shine_1_011.png";


//////////////////
// WEBPACK FOOTER
// ./src/games/fast-coin/img/coin/anim/shine_1/shine_1_011.png
// module id = 2327
// module chunks = 5